import "../pages/HealthCheckPage.css";

import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";

import UncoloredTable from "./UncoloredTable";
import {
    BrokenUrlDoc,
    EmptyProdRow,
    ManufacturerIntersection,
    SkippedProdsRow,
    UnexpectedKeywordRow
} from "features/healthcheck/types";
import FileUploader from "./GeneralFileUploader";

export const IntersectionsTable = ({result}: { result: ManufacturerIntersection[] }) => {
    const columns = ['name', 'tagsKeywords', 'Size', 'Shape', 'categories'];

    return (
        <FoldingTable name="Intersections" data={result} columns={columns}/>
    );
};

export const UnexpectedKwTable = ({result}: { result: UnexpectedKeywordRow[] }) => {
    const columns = ['name', 'tagsKeywords', 'Size', 'Shape', 'cat', 'keywords'];

    return (
        <FoldingTable name="Unexpected Keywords" data={result} columns={columns}/>
    );
};

export const IntersectedAttrsTable = ({result}: { result: UnexpectedKeywordRow[] }) => {
    const exclude = ['Row', 'URL', 'tagsKeywords', 'takeoffSize', 'Length', 'LengthM', 'Width', 'WidthM', 'Height', 'Volume', 'VolumeM', 'HeightM', 'specSheet', 'warrantySheet', 'maintenanceSheet', 'installationSheet', 'msdsSheet', 'imageFile', 'imageColor', 'productTypeId']
    const columns = Object.keys(result[0]).filter((key) => !exclude.includes(key));

    return (
        <FoldingTable name="Intersected Attributes" data={result} columns={columns}/>
    );
};

export const EmptyProdsTable = ({result}: { result: EmptyProdRow[] }) => {
    const columns = ['name', 'Size', 'specSheet', 'imageFile', 'cat'];

    return (
        <FoldingTable name="Empty products" data={result} columns={columns}/>
    );
};

export const BrokenUrlDocsTable = ({result}: { result: BrokenUrlDoc[] }) => {
    const columns = ['category', 'file_url', 'status'];

    return (
        <FoldingTable name="Broken URL Documents" data={result} columns={columns}/>
    );
};

export const BrokenSubsUrlDocsTable = ({result}: { result: BrokenUrlDoc[] }) => {
    const columns = ['category', 'file_url', 'status'];

    return (
        <FoldingTable name="Broken Subs URLs" data={result} columns={columns}/>
    );
};

export const SkippedProductsTable = ({currFileLen, currFileName, manNameN, result, setCurrFileLen, setCurrFileName}: { result: SkippedProdsRow[], manNameN: string, currFileName: string, setCurrFileName: React.Dispatch<React.SetStateAction<string>>, currFileLen: number, setCurrFileLen: React.Dispatch<React.SetStateAction<number>> }) => {
    const columns = ['collection', 'name', 'Size'];

    return (
        <FoldingTableWithFileUpload name="Skipped products" data={result} columns={columns} manNameN={manNameN} currFileName={currFileName} setCurrFileName={setCurrFileName} currFileLen={currFileLen} setCurrFileLen={setCurrFileLen}/>
    );
};

const FoldingTable = ({columns, data, name}: { name: string, data: ManufacturerIntersection[] | UnexpectedKeywordRow[] | EmptyProdRow[] | BrokenUrlDoc[], columns: string[] }) => {
    const [extended, setExtended] = useState<boolean>(false);

    return (
        <div className={"res-wrapper"}>
            <div className="res-container" onClick={() => {
                setExtended(!extended)
            }}>
                <p className="res-name">{name}{extended ? "" : " (" + data.length + " found)"}</p>
                <div className="chevron-wrapper">
                    <FontAwesomeIcon icon={extended ? faChevronUp : faChevronDown}/>
                </div>
            </div>
            <div className="extendable-res-container-w-table" style={{display: extended ? "flex" : "none"}}>
                <UncoloredTable result={data} columns={columns}/>
            </div>
        </div>
    );
};

const FoldingTableWithFileUpload = ({ columns, currFileLen, currFileName, data, manNameN, name, setCurrFileLen, setCurrFileName }: { name: string, manNameN: string, currFileName: string, setCurrFileName: React.Dispatch<React.SetStateAction<string>>, currFileLen: number, setCurrFileLen: React.Dispatch<React.SetStateAction<number>>, data: SkippedProdsRow[], columns: string[] }) => {
    const [extended, setExtended] = useState<boolean>(false);

    return (
        <div className={"res-wrapper"}>
            <div className="res-container" onClick={() => {
                setExtended(!extended)
            }}>
                <p className="res-name">{name}{extended ? "" : currFileLen === 0 ? " (complete list not specified)" : " (" + data.length + " found)"}</p>
                <div className="chevron-wrapper">
                    <FontAwesomeIcon icon={extended ? faChevronUp : faChevronDown}/>
                </div>
            </div>
            <div style={{display: extended ? "flex" : "none"}}>
                <FileUploader manNameN={manNameN} currFileName={currFileName} setCurrFileName={setCurrFileName} currFileLen={currFileLen} setCurrFileLen={setCurrFileLen}/>
            </div>
            {data.length > 0 ?
                <div className="extendable-res-container-w-table" style={{display: extended ? "flex" : "none"}}>
                    <UncoloredTable result={data} columns={columns}/>
                </div> : <></>}
        </div>
    );
};
